import React from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { ImageKitProvider } from '@imagekit/react'
import './index.css'
import App from './App'
import { IMAGEKIT_URL_ENDPOINT } from './config/imagekit'

const container = document.getElementById('root')
if (!container) throw new Error('root element not found')

createRoot(container).render(
  <React.StrictMode>
    <ImageKitProvider
      urlEndpoint={IMAGEKIT_URL_ENDPOINT}
      transformationPosition="path"
    >
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ImageKitProvider>
  </React.StrictMode>
)
